<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <!-- MODAL
    <div>
        <div class="modal fade" id="login-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
            aria-hidden="true">
            <form @submit.prevent>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                                &times;
                            </button>
                            <h4>Novo documento por tipo de usuário</h4>
                            <br />
                            <div class="form-group">
                                <label for="cadastro_tipo">Tipo cadastro</label>
                                <select class="form-control" id="cadastro_tipo" v-model="formData.cadastro_tipo">
                                    <option value="pf">PF</option>
                                    <option value="pj">PJ</option>
                                </select>

                                <span style="color: red" v-for="error in v$.cadastro_tipo.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="cadastro_tipo">Estado civil</label>
                                <select class="custom-select rounded-0" id="estado_civil" v-model="formData.estado_civil">
                                    <option value=""></option>
                                    <option value="uniao_estavel">União estável</option>
                                    <option value="casado">Casado</option>
                                    <option value="divorciado">Divorciado</option>
                                    <option value="separado_judicialmente">Separado judicialmente</option>
                                    <option value="viuvo">Viuvo</option>
                                    <option value="solteiro">Solteiro</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="tipo_doc">Tipo documento</label>
                                <input class="form-control" id="tipo_doc" type="text" v-model="formData.tipo_doc" />

                                <span style="color: red" v-for="error in v$.tipo_doc.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="obrigatorio">Obrigatório</label>
                                <select class="form-control" id="obrigatorio" v-model="formData.obrigatorio">
                                    <option :value="0">Sim</option>
                                    <option :value="1">Não</option>
                                </select>

                                <span style="color: red" v-for="error in v$.obrigatorio.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>

                            <button @click="validateFields()" class="btn btn-primary btn-flat">
                                Cadastrar <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
-->
  <!-- CADASTRO-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-body">
          <div class="row">
            <!-- NOME -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputEmail1">Nome completo</label>
                <input
                  class="form-control"
                  id="nome_completo"
                  placeholder="Nome"
                  v-model="formData.nome"
                  @blur="upper('nome')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.nome.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado_id"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                >
                  <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                    {{ estado.sigla }}
                  </option>
                </select>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.cidade_id" style="text-transform: uppercase">
                  <option v-for="cidade in my_cidades" :key="cidade.id" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- CPF/CNPJ -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="cpf_cnpj">CPF/CNPJ</label>
                <input
                  class="form-control"
                  id="cpf_cnpj"
                  placeholder="CPF ou CNPJ"
                  v-model="formData.cpf_cnpj"
                  @blur="upper('cpf_cnpj')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- EMAIL -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="email">Email</label>
                <input class="form-control" id="email" type="email" placeholder="Email" v-model="formData.email" />

              </div>
            </div>

            <!-- ENDEREÇO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="endereco">Endereço</label>
                <input
                  class="form-control"
                  id="endereco"
                  placeholder="Endereço"
                  v-model="formData.endereco"
                  @blur="upper('endereco')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- FONE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="fone">Fone</label>
                <input
                  class="form-control"
                  id="fone"
                  placeholder="Fone"
                  v-model="formData.fone"
                  @blur="upper('fone')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- NOME CONTRATO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="nome_contato">Nome contato</label>
                <input
                  class="form-control"
                  id="nome_contato"
                  placeholder="Nome contrato"
                  v-model="formData.nome_contato"
                  @blur="upper('nome_contato')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="validateFields()">Salvar</button>
          <a type="submit" href="/admin/comitentes" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["estados", "cidades", "comitente"],

  components: { Loading },

  data() {
    return {
      nome: "",
      isLoading: false,
      my_cidades: [],
    };
  },

  setup() {
    const formData = reactive({
      nome: "",
      endereco: "",
      cpf_cnpj: "",
      fone: "",
      nome_contato: "",
      cidade_id: "",
      estado_id: "",
      email: "",
    });

    const rules = computed(() => {
      return {
        nome: { required },
      };
    });

    const validarCPFOuCNPJ = (cpf_cnpj) => {
      //TENTANDO VALIDAR COMO CPF
      cpf_cnpj = cpf_cnpj.replace(/\D/g, "");
      if (cpf_cnpj.toString().length != 11 || /^(\d)\1{10}$/.test(cpf_cnpj)) result = false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf_cnpj
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf_cnpj.substring(j, j + 1)) result = false;
      });

      //TENTANDO VALIDAR COMO CNPJ
      if (!result) {
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        var c = String(cpf_cnpj).replace(/[^\d]/g, "");

        if (c.length !== 14) return false;

        if (/0{14}/.test(c)) return false;

        for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
        if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

        for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
        if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

        return true;
      } else {
        return result;
      }
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.my_cidades = this.cidades;

    this.formData.nome = this.comitente.nome;
    this.formData.endereco = this.comitente.endereco;
    this.formData.cpf_cnpj = this.comitente.cpf_cnpj;
    this.formData.fone = this.comitente.fone;
    this.formData.nome_contato = this.comitente.nome_contato;
    this.formData.cidade_id = this.comitente.cidade_id;
    this.formData.estado_id = this.comitente.estado_id;
    this.formData.email = this.comitente.email;
  },

  methods: {
    upper(field_name) {
      console.log(field_name);
      this.formData[field_name] = this.formData[field_name].toUpperCase();
      console.log(this.formData[field_name]);
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.update();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.comitente.id,
        nome: this.formData.nome,
        endereco: this.formData.endereco,
        cpf_cnpj: this.formData.cpf_cnpj,
        fone: this.formData.fone,
        nome_contato: this.formData.nome_contato,
        cidade_id: this.formData.cidade_id,
        estado_id: this.formData.estado_id,
        email: this.formData.email,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/comitente/update`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButton("Sucesso", "Dados editados");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.estado_id,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.my_cidades = response.data.cidades;

          this.formData.cidade_id = null;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>
